import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

import looseLeafListStore from '../../stores/LooseLeafListStore';
import looseLeafStore from '../../stores/LooseLeafStore';

import TitleBar from '../TitleBar';
import LooseLeafList from './LooseLeafList';
import LooseLeafDrawer from './LooseLeafDrawer';


@inject("appStore")
@observer
class LooseLeafUI extends Component {

    constructor(props) {
        super(props);
        this.looseLeafListStore = looseLeafListStore;
    }

    render() {
        const context = this.props.context;
        return (
            <div style={{height: '100%', width: '100%'}}>
                <TitleBar/>
                <LooseLeafList
                    looseLeafListStore={this.looseLeafListStore}
                    looseLeafStore={looseLeafStore}
                    context={context}
                />
                <LooseLeafDrawer
                    visible={looseLeafStore.drawerVisible}
                />
            </div>
        )
    }
}

export default LooseLeafUI;
